export enum StudentRosteringType {
  HANDENTER = 'HAND_ENTER',
  UPLOADCSV = 'UPLOAD_CSV',
  GOOGLECLASSROOM = 'GOOGLE_CLASSROOM',
  CLEVERSSO = 'CLEVER',
  CLASSLINK = 'CLASSLINK',
  SHIBBOLETH = 'SHIBBOLETH',
}

export type RosteringProvider = Omit<
  keyof typeof StudentRosteringType,
  'HANDENTER' | 'UPLOADCSV'
>;
